import { render, staticRenderFns } from "./CheckboxIcon.vue?vue&type=template&id=851d8f26&scoped=true"
import script from "./CheckboxIcon.vue?vue&type=script&lang=js"
export * from "./CheckboxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851d8f26",
  null
  
)

export default component.exports